
/**
 * Component for header with navigation.
 *
 * @component
 * @return { HTMLElement }
 */
function HeaderCreaCompte() {

    return (<>
        <header className="header">
            <div className='logo-header-left'><img src={`${process.env.PUBLIC_URL}/img/logo_CarifOref.png`} alt="Carif Oref Paca" className="feature-icon" /></div>
            <div className='titre-header'><h1>Extranet - Demande de code d'accès</h1></div>
        </header>


            <div className='image-presentation-short'>
                <img src={`${process.env.PUBLIC_URL}/img/image_presentation.png`} alt="Carif Oref Paca"  className="feature-presentation-short" />
            </div>

    </>
    )
}

export default HeaderCreaCompte